import React, { useState } from 'react';

import { Alert, AlertTitle } from '@material-ui/lab';
//import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
//import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers';
import * as yup from "yup";

import Copyright from '../components/Copyright';
import AlertGlobalErrors from '../components/AlertGlobalErrors';

import authApi from '../api/auth';

import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 0),
  },
}));

const schema = yup.object().shape({
  password: yup.string()
    .trim()
    .required('Es requerido')
    /*
    .test(
      'containsUpperCase',
      "La contraseña debe contener mayúsculas",
      (value) => /[A-Z]/.test(value),
    )
    .test(
      'containsLowerCase',
      "La contraseña debe contener minúsculas",
      (value) => /[a-z]/.test(value),
    )
    .test(
      'containsNumber',
      "La contraseña debe contener un número",
      (value) => /[0-9]/.test(value),
    )
    .test(
      'containsSpecialCharacter',
      "La contraseña debe contener caracteres especiales",
      (value) => /[!#$%&'()*+,-./:;<=>?@[\]^_{|}~]/.test(value),
    )
    */
    .max(255, 'Debe contener como máximo 255 carácteres')
  ,
  confirmPassword: yup.string()
    .trim()
    .required('Es requerido')
    .oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir')
  ,
});

const ChangePassword = (props) => {
  const classes = useStyles();

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema)
  });
  const [serverErros, setServerErrors] = useState();
  const [showMessage, setShowMessage] = useState(false);

  const onSubmit = async data => {
    setServerErrors();
    try {
      const params = (new URL(document.location)).searchParams;
      const token = params.get('token');
      await authApi.changePassword({
        ...data,
        token
      });
      setShowMessage(true);
    } catch (error) {
      console.log(error);
      if (error.message === 'Network Error') {
        setServerErrors([{
          type: 'network_error',
          title: 'Error de Red',
          message: 'no se pudo conectar con el servidor'
        }]);
      } else if (error.response.status === 500) {
        setServerErrors([{
          type: 'internal_server_error',
          title: 'Error interno del servidor',
          message: 'sucedió un error interno en el servidor, contacte con el administrador si este persiste'
        }]);
      } else if ([401, 403].includes(error.response.status)) {
        const body = error.response.data;
        setServerErrors([{
          type: body.type,
          title: 'Autentificación',
          message: body.error
        }]);
      } else {
        console.log(error.response);
        const body = error.response.data;
        setServerErrors(body.errors.map((input) => {
          return {
            type: 'body',
            property: input.property,
            messages: Object.values(input.constraints).map(item => item.toLocaleLowerCase())
          }
        }));
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img src='/bewo.png' width='150px' alt='Logo' style={{marginBottom: "20px"}}/>
        {
          /*
        <Avatar className={classes.avatar}>
          <VpnKeyIcon />
        </Avatar>
          */
        }
        <Typography component="h1" variant="h5">
          Cambiar contraseña
        </Typography>
        {
          showMessage ?
            <Alert severity="success">
              <AlertTitle>Contraseña cambiada exitosamente</AlertTitle>
              <Typography component="p">
                Su contraseña se ha cambiado exitosamente, a continuación inicia sesión.
              </Typography>
            </Alert> :
            <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
              <AlertGlobalErrors errors={serverErros} />
              <TextField
                inputRef={register}
                error={!!errors.password && Object.keys(errors.password).length === 0}
                helperText={errors.password?.message}
                variant="outlined"
                margin="normal"
                fullWidth
                name="password"
                label='Contraseña'
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <TextField
                inputRef={register}
                error={!!errors.confirmPassword && Object.keys(errors.confirmPassword).length === 0}
                helperText={errors.confirmPassword?.message}
                variant="outlined"
                margin="normal"
                fullWidth
                name="confirmPassword"
                label='Confirmar contraseña'
                type="password"
                id="confirmPassword"
                autoComplete="current-password"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Cambiar contraseña
                    </Button>
            </form>
        }
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="default"
          className={classes.submit}
          component={RouterLink}
          to="/"
        >
          Iniciar Sesión
        </Button>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

export default ChangePassword;